export default {
  funcionario: {
    value: null,
    code: null,
    options: [],
    state: null
  },
  nome: {
    value: null,
    maxlength: '70',
    required: false,
    state: null,
    disabled: false
  },
  cargoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  situacao: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  admissao: {
    value: null,
    maxlength: '10',
    required: true,
    state: null,
    disabled: false
  },
  dataExperiencia1: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  dataExperiencia2: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  avisoPrevio: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  ferias: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  dataAfastamento: {
    value: null,
    maxlength: '10',
    required: false,
    state: null,
    disabled: false
  },
  refeicaoQuantidade: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  },
  refeicaoValorUnitario: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  },
  valeAlimentacao: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  },
  cafeManhaValor: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  },
  valeTransporteQuantidade: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  },
  valeTransporteValorUnitario: {
    value: 0,
    maxlength: '20',
    required: true,
    state: null,
    disabled: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/board/components/addemployee/addemployee-form.js